// extracted by mini-css-extract-plugin
export var discard = "_4g-3";
export var muiTooltipTooltip = "_4g-5";
export var notificationBar = "_4g-2";
export var saveButtonHoverSlotWrapper = "_4g-4";
export var show = "_4g-1";
export var spacer = "_4g-0";